import React, { useContext } from 'react';

import CDFILogo from '../../assets/images/amazon/CDFILogo.png';
import bankLogo from '../../assets/images/amazon/bankLogo.png';
import TenantConfig from '../../config';
import { UserContext } from '../../context/UserContext';
import { sanitizeHtml } from '../../helpers/format';

const Footer = ({ breakpoint }) => {
  const { width } = useContext(UserContext);

  const contacts = TenantConfig?.footer.contacts;
  const termSectionLinks = TenantConfig?.footer.termLinks;

  const aboutCompanyLinks = TenantConfig?.footer.aboutCompanyLinks;

  const footerInfoData = {
    copyrightInfo: TenantConfig?.footer.copyright,
    sponsor: TenantConfig?.footer.sponsor,
  };

  const renderCopyRightSection = () => {
    switch (getTenant()) {
      case 'amazon':
      case 'lightrx':
        return (
          <>
            <div className="bottom-section d-flex">
              <div className="link-group-item">
                <p>© 2022 B.S.D. Capital, Inc. dba</p>

                <p>Lendistry.</p>

                <p>California Financial Lender</p>
              </div>
              <div className="link-group-item">
                <p>License #60DBO66872</p>
                <p>NMLS# 1945565</p>
                <p>All Rights Reserved.</p>
              </div>
            </div>
            <div className="footer-border-no-bottom-marging" />
            <div className={`bottom-section d-flex ${getTenant()}-logos`}>
              <div className="logoItem">
                <img src={TenantConfig.footerLogo} alt="logo" />
              </div>
              <div className="logoItem">
                <img src={CDFILogo} alt="CDFI Logo" />
              </div>
              <div className="logoItem">
                <img src={bankLogo} alt="logo" />
              </div>
              <div className="logoItem"></div>
            </div>
          </>
        );
      case ('sba', 'smbcontractor'):
        return (
          <>
            <div className="bottom-section d-flex">
              <div className="link-group-item lendistry-legal">
                <p>
                  ©2022 B.S.D. Capital, Inc. dba Lendistry. All rights reserved. Loans originated by
                  B.S.D. Capital, Inc. dba Lendistry are made pursuant to state law and may not be
                  available in all states. SBA loans originated by Lendistry SBLC, LLC, a wholly
                  owned subsidiary of B.S.D. Capital, Inc. dba Lendistry. Lendistry SBLC, LLC is
                  approved to offer SBA loan products under SBA's 7(a) Lender Program.
                </p>
                <p>
                  <strong>California residents:</strong> Loans made or arranged pursuant to a
                  California Finance Law license. B.S.D. Capital, Inc. dba Lendistry California
                  Finance Lender, License #60DBO-66872. NMLS# 1945565. Lendistry SBLC, LLC
                  California Finance Lender, License #60DBO-49327. NMLS# 1571851.
                </p>
              </div>
            </div>
            <div className="footer-border-no-bottom-marging" />
            <div className={`bottom-section d-flex ${getTenant()}-logos`}>
              <div className="logoItem">
                <img src={TenantConfig.footerLogo} alt="logo" />
              </div>
              <div className="logoItem">
                <img src={CDFILogo} alt="CDFI Logo" />
              </div>
              <div className="logoBankItem">
                <img src={bankLogo} alt="FHL Bank Logo" />
              </div>
              <div className="logoItem"></div>
            </div>
          </>
        );
      case 'cavenuesgrant':
      case 'venues-crg':
      default:
        return (
          <div className="bottom-section d-flex">
            <div>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(footerInfoData?.copyrightInfo),
                }}
              />
            </div>
            <div>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(footerInfoData?.sponsor),
                }}
              />
            </div>
          </div>
        );
    }
  };

  const renderInstructions = () => {
    return (
      TenantConfig?.footer.renderInstructions && (
        <div className="link-group-item">
          <p className="group-title">Instructions</p>
          <div className="footer-link-item">
            <a
              href="http://www.lendistry.com/amazon-application-guide"
              target="_blank"
              rel="noreferrer"
            >
              Application Guide
            </a>
          </div>
          <div className="footer-link-item">
            <a
              href="http://www.lendistry.com/amazon-application-guide"
              target="_blank"
              rel="noreferrer"
            >
              FAQs
            </a>
          </div>
        </div>
      )
    );
  };

  const renderTerms = () => {
    return (
      <div className="footer-link-item">
        {termSectionLinks?.map((linkItem, index) => (
          <div className="footer-link-item" key={index}>
            <a href={linkItem.url} target="_blank" rel="noreferrer">
              {linkItem.description}
            </a>
          </div>
        ))}
      </div>
    );
  };

  const renderContactUs = () => {
    return (
      <div className="link-group-item contact-us" id="contact">
        <p className="group-title">Contact Us</p>
        {contacts?.map((linkItem, index) => (
          <p key={'contact' + index}>
            <a
              href={linkItem.url}
              target="_blank"
              rel="noreferrer"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(linkItem.description),
              }}
            />
          </p>
        ))}
      </div>
    );
  };

  return (
    <div
      className={`${
        width >= breakpoint ? 'landing-footer' : 'mobile-landing-footer'
      } ${getTenant()}`}
    >
      <div className="footer-inner">
        <div className="top-section">
          <div className="link-group-item">
            <p className="group-title">Terms and Conditions</p>
            {renderTerms()}
          </div>
          {renderInstructions()}
          <div className="link-group-item">
            <p className="group-title">About Lendistry</p>
            {aboutCompanyLinks?.map((linkItem, index) => (
              <div className="footer-link-item" key={index}>
                <a href={linkItem.url} target="_blank" rel="noreferrer">
                  {linkItem.description}
                </a>
              </div>
            ))}
          </div>
          {renderContactUs()}
          {!!TenantConfig?.footer.programGuideLine?.render && (
            <div className="link-group-item">
              <p className="group-title">{TenantConfig?.footer.programGuideLine.headerText}</p>
              {TenantConfig?.footer.programGuideLine.programGuideLineButtons.map(
                (linkItem, index) => (
                  <div className="footer-link-item" key={index}>
                    <a href={linkItem.link} target="_blank" rel="noreferrer">
                      {linkItem.text}
                    </a>
                  </div>
                )
              )}
            </div>
          )}
        </div>
        <div className="footer-border" />
        {renderCopyRightSection()}
      </div>
    </div>
  );
};

export default Footer;
